import { render, staticRenderFns } from "./consumptionCarouselItem.vue?vue&type=template&id=4714d6a6&scoped=true&"
import script from "./consumptionCarouselItem.vue?vue&type=script&lang=js&"
export * from "./consumptionCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./consumptionCarouselItem.vue?vue&type=style&index=0&id=4714d6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714d6a6",
  null
  
)

export default component.exports